import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarExpanded: false,
  mobileSearchOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarExpanded = !state.sidebarExpanded;
    },
    setSidebar(state, action) {
      state.sidebarExpanded = action.payload;
    },
    toggleMobileSearch(state) {
      state.mobileSearchOpen = !state.mobileSearchOpen;
    },
  },
});

export const { toggleSidebar, setSidebar, toggleMobileSearch } = uiSlice.actions;
export default uiSlice.reducer;
